import { decode, isBlurhashValid } from 'blurhash'
import { useEffect, useRef } from 'react'

export function BlurhashCanvas({ hash, width = 32, height = 32 }: { hash: string; width?: number; height?: number }) {
  const ref = useRef<HTMLCanvasElement>(null)
  useEffect(() => {
    const canvas = ref.current
    if (!canvas || !isBlurhashValid(hash).result) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    const pixels = decode(hash, width, height)
    const image = ctx.createImageData(width, height)
    image.data.set(pixels)
    ctx.putImageData(image, 0, 0)
  }, [hash, width, height])
  return <canvas ref={ref} width={width} height={height} aria-hidden="true" />
}
